var _circle, _circle2, _line, _line2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConnect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.524,
    cy: 16.4381,
    r: 13.4381,
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5621,
    cy: 83.5618,
    r: 13.4381,
    stroke: "white",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 24.0953,
    y2: -1,
    transform: "matrix(0.867165 -0.498021 0.501981 0.864879 42.1592 35.6001)",
    stroke: "white",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 24.0953,
    y2: -1,
    transform: "matrix(0.867165 0.498021 -0.501981 0.864879 42.1592 64.3999)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5015 50C50.5015 60.6319 41.8826 69.2508 31.2508 69.2508C20.6189 69.2508 12 60.6319 12 50C12 39.3681 20.6189 30.7493 31.2508 30.7493C41.8826 30.7493 50.5015 39.3681 50.5015 50Z",
    fill: "#F0C43F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2505 62.0317C24.6055 62.0317 19.2188 56.6449 19.2188 50M31.2505 37.9683C37.8954 37.9683 43.2822 43.355 43.2822 50M50.5015 50C50.5015 60.6319 41.8826 69.2508 31.2508 69.2508C20.6189 69.2508 12 60.6319 12 50C12 39.3681 20.6189 30.7493 31.2508 30.7493C41.8826 30.7493 50.5015 39.3681 50.5015 50Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConnect);
export default __webpack_public_path__ + "static/media/icon-connect.556b6fd5b34caa17f715190fd51a7ee9.svg";
export { ForwardRef as ReactComponent };